export default __webpack_public_path__ + "static/media/React95Video-Numbers.cc52603d.woff";